import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path
      fill="currentColor"
      d="M11 2v9H2v2h9v9h2v-9h9v-2h-9V2z"
      fillRule="evenodd"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/IconPlus.jsx